import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    entitiesAbanderado: null,
    entitiesEstatales: null,
    hermano: undefined,
    familiar: undefined,
    establecimientoInformacion: undefined,
    lastError: null
};

export const callTypes = {
    list: "list",
    action: "action"
};

export const establecimientoSlice = createSlice({
    name: "establecimiento",
    initialState: initialState,
    reducers: {
        catchError: (state, action) => {
            state.error = action.payload.error.clientMessage;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            };
        },
        starCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            };
        },
        establecimientosFetched: (state, action) => {
            const { establecimientos } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = establecimientos;
            state.totalCount = establecimientos & establecimientos.length;
        },
        establecimientosAbanderadoFetched: (state, action) => {
            const { establecimientos } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entitiesAbanderado = establecimientos;
            state.totalCount = establecimientos & establecimientos.length;
        },
        establecimientosEstatalesFetched: (state, action) => {
            const { establecimientos } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entitiesEstatales = establecimientos;
            state.totalCount = establecimientos & establecimientos.length;
        },
        hermanoFetched: (state, action) => {
            const { hermano } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.hermano = hermano;
        },
        familiarFetched: (state, action) => {
            const { familiar } = action.payload;
            state.listLoading = false;
            state.error = null;
            state.familiar = familiar;
        },
        stateLimpiar: (state, action) => {
            state.listLoading = false;
            state.entities = null;
            state.entitiesAbanderado = null;
            state.entitiesEstatales = null;
            state.hermano = undefined;
            state.familiar = undefined;
            state.establecimientoInformacion = undefined;
        },
    }
});